import * as Sentry from "@sentry/react";
import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App.tsx";
import "./index.css";

Sentry.init({
  dsn: "https://85eda1282615cfc490d1b1e6d4161cc8@o4511334855737344.ingest.us.sentry.io/4511344069509120",
  environment: import.meta.env.MODE,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      // Habeas Data (Ley 1581) + confidencialidad: NO grabar datos personales en
      // claro. Enmascara todo el texto y los inputs, y bloquea imágenes/media.
      // Las grabaciones se envían a Sentry (US); sin esto se filtrarían nombres,
      // correos, diagnósticos, conversaciones con LIA y tablas de pagos.
      maskAllText: true,
      maskAllInputs: true,
      blockAllMedia: true,
    }),
  ],
  tracesSampleRate: import.meta.env.PROD ? 0.2 : 1.0,
  replaysSessionSampleRate: 0.05,
  replaysOnErrorSampleRate: 1.0,
  ignoreErrors: [
    "ResizeObserver loop limit exceeded",
    "ResizeObserver loop completed with undelivered notifications",
  ],
});

createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <App />
  </HelmetProvider>
);
